<template>
  <qx-card-form
    :title="costType === 2009 ? '事故信息' : '明细信息'"
    v-show="costType || $route.query.vehicleFeeType === '2'"
  >
    <span slot="titleLeft">
      <span class="payAmtText" v-show="otherFormData.payAmt">
        申请总金额：
        <span class="primary">{{otherFormData.payAmt}}</span>
      </span>
      <!-- <span class="payAmtText" v-show="costType === 2008 && otherFormData.affaires">
        代办处理费：
        <span class="primary">{{otherFormData.affaires}}</span>
        <el-tooltip content="代办处理费包括罚金和代办手续费总的费用">
          <i class="el-icon-question warning payAmtText" />
        </el-tooltip>
      </span>-->
      <span class="payAmtText" v-show="costType === 4016 && otherFormData.purchaseFee">
        采购总金额：
        <span class="primary">{{otherFormData.purchaseFee}}</span>
      </span>
    </span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="vehicleFeeFileDetails" slot-scope="prop">
        <!-- 加油费 -->
        <Oil
          v-if="costType === 3001"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 维修保养 -->
        <Maintenance
          v-if="costType === 2020"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          :serviceInfo="serviceInfo"
          @change="handleDetailChange"
        />
        <!-- 过路费 -->
        <Toll
          v-if="costType === 3007"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
        <!-- 停车费 -->
        <ParkingFee
          v-if="costType === 2010"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 其他费 -->
        <Other
          v-if="costType === 2022"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 年审费 -->
        <AnnualReview
          v-if="costType === 2005"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 保险费 -->
        <Insurance
          v-if="costType === 2006"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 违章费 -->
        <Violation
          v-if="costType === 2008"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 事故 -->
        <Accident
          v-if="costType === 2009"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
        <!-- gps -->
        <Gps
          v-if="costType === 4015"
          v-model="prop.form.vehicleFeeFileDetails"
          :orgId="orgId"
          @change="handleDetailChange"
        />
        <!-- 尿素 -->
        <Urea
          v-if="costType === 2012"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
        <!-- 车辆租金 -->
        <Rent
          v-if="costType === 2002"
          v-model="prop.form.vehicleFeeFileDetails"
          :serviceInfo="serviceInfo"
          @change="handleDetailChange"
        />
        <!-- 信息费 -->
        <Info
          v-if="costType === 4021 || costType === 4019"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
        <!-- 导流罩 -->
        <Shroud
          v-if="costType === 4016"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
        <!-- 订单 -->
        <OrderFee
          v-if="$route.query.vehicleFeeType === '2'"
          v-model="prop.form.vehicleFeeFileDetails"
          :otherDialogData="otherDialogData.orderFee"
          :orgId="Number(orgId)"
          @change="handleDetailChange"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
  getFileUrl,
} from 'api';
import Maintenance from './maintenance/maintenance'; // 维修保养
import Oil from './oil/oil'; // 加油费
import Toll from './toll/toll'; // 过路费
import ParkingFee from './parkingFee/parkingFee'; // 停车费
import Other from './other/other'; // 其他车辆费
import AnnualReview from './annualReview/annualReview'; // 年审费
import Insurance from './insurance/insurance'; // 保险费
import Violation from './violation/violation'; // 违章费
import Gps from './gps/gps'; // gps
import Accident from './accident/accident'; // 事故
import Urea from './urea/urea'; // 尿素
import Rent from './rent/rent'; // 车辆租金
import Info from './info/info'; // 信息费
import Shroud from './shroud/shroud'; // 导流罩
import OrderFee from './orderFee/orderFee'; // 订单
export default {
  components: {
    Maintenance, // 维修保养
    Oil, // 加油费
    Toll, // 过路费
    ParkingFee, // 停车费
    Other, // 其他车辆费
    AnnualReview, // 年审费
    Insurance, // 保险费
    Violation, // 违章费
    Accident, // 事故
    Gps, // Gps
    Urea, // 尿素
    Rent, // 车辆租金
    Info, // 信息费
    Shroud, // 导流罩
    OrderFee, // 订单
  },
  data () {
    return {
      serviceInfo: {},
      orgId: '',
      costType: '',
      otherFormData: {
        payAmt: 0, // 申请总金额
        affaires: 0, // 代办处理费
        purchaseFee: 0, // 采购总金额
      },
      otherDialogData: {
        // 订单明细
        orderFee: {
          plateNumber: '',
          carDriverMan: '',
        },
      },
      baseForm: {
        balanceTypeOptions: [],
        form: [
          {
            label: '明细信息',
            value: 'vehicleFeeFileDetails',
            default: [],
            slot: true,
          },
          // {
          //   label: '费用说明',
          //   value: 'feeRemark',
          //   type: 'input',
          //   attr: {
          //     type: 'textarea',
          //   },
          // },
          // {
          //   label: '上传附件',
          //   value: 'file',
          //   type: 'img',
          //   accept: 'image/*',
          //   fileSize: 5120,
          //   default: [],
          // },
        ],
        rules: {
          vehicleFeeFileDetails: [ // 明细信息
            { required: true, message: '请修改明细信息', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleDetailChange () {
      const vehicleFeeFileDetails = this.$refs.baseForm.getVal('vehicleFeeFileDetails');
      // 申请金额
      this.otherFormData.payAmt = 0;
      if (vehicleFeeFileDetails) {
        vehicleFeeFileDetails.forEach((item) => {
          if (!isNaN(item.payAmt)) {
            this.otherFormData.payAmt += Number(item.payAmt);
          }
        });
        this.$emit('getOtherFormVal', {
          from: 'receipt',
          tar: 'detailForm',
        });
      }
      // 代办处理费
      this.otherFormData.affaires = 0;
      if (this.costType === 2008 && vehicleFeeFileDetails) {
        vehicleFeeFileDetails.forEach((item) => {
          if (!isNaN(item.violationFine)) { // 罚金
            this.otherFormData.affaires += Number(item.violationFine);
          }
          if (!isNaN(item.otherFee)) { // 代办处理费
            this.otherFormData.affaires += Number(item.otherFee);
          }
        });
      }
      // 采购总金额
      this.otherFormData.purchaseFee = 0;
      if (vehicleFeeFileDetails) {
        vehicleFeeFileDetails.forEach((item) => {
          if (!isNaN(item.purchaseFee)) {
            this.otherFormData.purchaseFee += Number(item.purchaseFee);
          }
        });
      }
    },
    receiveData (tar, val) {
      this.orgId = val.orgId;
      if (val.costType) {
        this.costType = Number(val.costType);
        // this.otherFormData.payAmt = 0;
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: this.costType === 2009,
          names: ['desc', 'file'],
        });
        if (this.costType === 2002 || this.costType === 2020) {
          // 车辆租金
          this.serviceInfo = {
            serviceId: val.serviceId,
            serviceName: val.serviceName,
            servicePhone: val.servicePhone,
          };
        }
      } else {
        this.costType = '';
      }
      if (this.$route.query.vehicleFeeType === '2') {
        // 订单费用报销的时候，查询订单需要 车牌号 和 司机姓名 去筛选订单
        this.otherDialogData.orderFee = {
          plateNumber: val.plateNumber || '',
          carDriverMan: val.driverName || '',
        };
      }
    },
    async getList () {
      const enumsData = await getEnumList({
        codeType: 'BALANCE_TYPE',
      });
      this.baseForm.balanceTypeOptions = enumsData[0];
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      let res = await this.handleSubData(true);
      return res;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.vehicleFeeFileDetails.forEach((item) => {
          item.costType = `${item.costType || this.costType}`;
          item.licenceType = `${item.licenceType || ''}`;
          item.id = item.id || '';
          if (item.detailPic) {
            if (this.costType === 2020) {
              // 维护保养附件的字段名和其他的不一样
              item.fileIds = item.detailPic.map((item) => item.id);
              item.fileIds = item.fileIds.join(',');
            } else {
              item.detailPic = item.detailPic.map((item) => item.id);
              item.detailPic = item.detailPic.join(',');
            }
          }
          // 删除多余的参数，多出来会报错
          if (this.costType === 2005) {
            delete item.userType;
          }
          if (this.costType === 2006) {
            delete item.userType;
          }
          if (this.costType === 2020) {
            delete item.detailPic;
          }
        });
        formData.vehicleFeeFileDetails = JSON.stringify(formData.vehicleFeeFileDetails);
        if (this.costType === 2020) {
          // 如果是 维修保养费 ，提交的字段名改换成 vehicleFeeCostDetails
          formData.vehicleFeeCostDetails = formData.vehicleFeeFileDetails;
          // 删除多余参数
          delete formData.vehicleFeeFileDetails;
        }

        // 上传附件
        if (formData.file && formData.file.length) {
          formData.fileId = formData.file.map((item) => item.id);
          formData.fileId = formData.fileId.join(',');
          delete formData.file;
        }
        // 上传附件 end
      }
      return formData;
    },
    async init (data = {}) {
      let flowIds = [];
      let urlRes = [];
      // 因为有的图片只返回一个不可读的地址，所以要重新去请求接口获取完整的图片地址，放在下面的循环中不好处理，所以就放在这处理了
      if (data.costDetails) {
        data.costDetails.forEach((item) => {
          if (item.detailPic && item.detailPic.length) {
            item.detailPic.forEach((file) => {
              flowIds.push(file.fileId);
            });
          }
        });
        if (flowIds.length) {
          urlRes = await getFileUrl({
            flowIds: flowIds.join(','),
            _GRID_TYPE: 'jq',
          });
        }
      }

      // 详情数据
      if (data.costDetails) {
        data.costDetails.forEach(async (item) => {
          if (item.detailPic) {
            if (urlRes && urlRes.rows) {
              for (let file of urlRes.rows) {
                for (let pic of item.detailPic) {
                  if (file.flowId === pic.fileId) {
                    pic.id = pic.fileId;
                    pic.url = file.fullPath;
                  }
                }
              }
            }
          }
          if (item.fileIds && item.fileIds.length) {
            item.detailPic = item.fileIds.map((item) => ({
              id: item.fileId,
              url: item.fileUrl,
            }));
          }
          // TODO 有点奇怪要*100才是正确的数据
          if (item.parkPrice !== undefined) {
            item.parkPrice = `${item.parkPrice * 100}`;
          }
          if (item.parkTime !== undefined) {
            item.parkTime = this.formatDate(item.parkTime);
          }
          if (item.categoryId !== undefined && item.categoryId !== null) {
            item.categoryId = String(item.categoryId);
          }
          if (item.violationPoint !== undefined && item.violationPoint !== null) {
            item.violationPoint = String(item.violationPoint);
          }
          // 尿素 - 产品类型
          if (item.ureaType !== undefined && item.ureaType !== null) {
            item.ureaType = String(item.ureaType);
            if (item.ureaType === '1') {
              item.ureaTypeName = '桶装';
            } else {
              item.ureaTypeName = '散装';
            }
          }
          // 事故 - 理赔类型
          if (item.lossType !== undefined && item.lossType !== null) {
            item.lossType = String(item.lossType);
            if (item.ureaType === '1') {
              item.lossTypeName = '车损';
            } else if (item.ureaType === '2') {
              item.lossTypeName = '路损';
            } else if (item.ureaType === '3') {
              item.lossTypeName = '人损';
            } else if (item.ureaType === '4') {
              item.lossTypeName = '物损';
            }
          }
          item.busiType = item.certificatesInsuranceType || '';
        });
        data.vehicleFeeFileDetails = data.costDetails;
      } else if (!data.vehicleFeeFileDetails) {
        data.vehicleFeeFileDetails = [];
      }
      // 附件
      if (data.picList) {
        data.file = data.picList.map((item) => ({
          id: item.fileId,
          url: item.fileUrl,
        }));
      } else {
        data.file = [];
      }

      this.$refs.baseForm.setVal('form', data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
.payAmtText {
  margin-left: 16px;
  color: #999;
}
</style>
